import React from 'react';
import { keyLaneToX, timePosToY, trackLaneToX } from './lane';
import { EditContainer } from '../store/EditContainer';
import { CursorNotePosition } from '../store/types';

interface Props {
  position: CursorNotePosition;
}

export const CursorNote: React.FC<Props> = props => {
  const { verticalZoom } = EditContainer.useContainer();
  const x = props.position.isKey ? keyLaneToX(props.position.lane) : trackLaneToX(props.position.track);

  return (
    <div className="CursorNote"
      style={{
        left: x,
        top: timePosToY(props.position.timePos, verticalZoom)
      }}
    >
    </div>
  );
};
